(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbl-product-detail"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.pbl-pdp__variants input[type="radio"]')) return;
    const form = event.target.closest('.pbl-pdp__form');
    const productInfo = form.closest('.pbl-pdp__info');
    const price = form.querySelector('[id^="PblProductPrice-"]');
    const compareAt = form.querySelector('[id^="PblProductCompareAt-"]');
    const submit = form.querySelector('.pbl-pdp__atc');
    const format = productInfo.querySelector('[id^="PblProductFormat-"]');
    const sku = productInfo.querySelector('[id^="PblProductSku-"]');
    const isAvailable = event.target.dataset.available === 'true';

    if (price && event.target.dataset.price) price.textContent = event.target.dataset.price;
    if (compareAt) {
      compareAt.textContent = event.target.dataset.compareAt || '';
      compareAt.hidden = !event.target.dataset.compareAt;
    }
    if (submit) {
      submit.disabled = !isAvailable;
      submit.textContent = isAvailable ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;
    }
    if (format) format.textContent = event.target.dataset.title || '';
    if (sku) sku.textContent = event.target.dataset.sku || '';
  });

  } catch(e) { console.error(e); }
})();
})();
